import { render, staticRenderFns } from "./k-footer.vue?vue&type=template&id=024f00b5&scoped=true&"
import script from "./k-footer.vue?vue&type=script&lang=js&"
export * from "./k-footer.vue?vue&type=script&lang=js&"
import style0 from "./k-footer.vue?vue&type=style&index=0&id=024f00b5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f00b5",
  null
  
)

export default component.exports